import { Section } from "./PortalPage";
import { ClientNotificationMatrix } from "./ClientNotificationMatrix";
import { EmailDeliveryCard } from "./EmailDeliveryCard";
import { useNotificationPrefs } from "./useNotificationPrefs";

export function ClientNotificationSettings() {
  const { data, error, push, sendPending } = useNotificationPrefs();
  if (error) return <p className="text-sm text-destructive" data-testid="notif-prefs-error">{error}</p>;
  if (!data) return <div className="flex justify-center py-10" data-testid="notif-prefs-loading"><div className="animate-spin h-6 w-6 border-2 border-primary border-t-transparent rounded-full" /></div>;
  return (
    <div className="space-y-6" data-testid="client-notification-settings-body">
      <Section title="How emails reach you" testid="email-delivery-section">
        <EmailDeliveryCard data={data} push={push} sendPending={sendPending} />
      </Section>
      <Section title="What you're notified about" testid="notif-prefs-section">
        <ClientNotificationMatrix data={data} push={push} />
      </Section>
    </div>
  );
}
